import React from "react";
import { API_URL } from "../../../constants";
import { useState, useEffect } from "react";
import { GetServiceCaller } from "../../../services/serviceCaller";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { useNavigate } from "react-router-dom";
import FuseLoading from "../../../components/FuseLoading";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";

const ClientMaster = () => {
  const navigate = useNavigate();
  const [reportList, setReplortList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [apiStatus, setApiStatus] = useState(undefined);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Client Master"));
  }, []);

  useEffect(() => {
    fetchReportList();
  }, [searchTerm]);

  const fetchReportList = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}clientmaster`);
      if (response?.status===200) {

        setReplortList(response?.data?.data?.header);
        setApiStatus(response?.status);
      }
    } catch (error) {
      console.error("Error fetching reports", error);
    }
  };

  const columns = {
    Code: { text: "Client ID", align: "start", visible: true },
    Name: { text: "Client Name", align: "start", visible: true },
    City: { text: "City", align: "start", visible: true },
    CP_Name: { text: "Client Partner", align: "start", visible: true },
    DP_Name: { text: "Delivery Partner", align: "start", visible: true },
    DH_Name: { text: "Delivery Head", align: "start", visible: true },
    PM_Name: { text: "Project Manager", align: "start", visible: false },
    ROMPoC: { text: "RMG POC", align: "start", visible: true },
    Domain: { text: "Domain", align: "start", visible: false },
    LocationType: { text: "Location Type", align: "start", visible: false },
    StartDate: { text: "Start Date", align: "center", visible: true },
    EndDate: { text: "End Date", align: "center", visible: true },
    Country: { text: "Country", align: "start", visible: false },
    Sate: { text: "State", align: "start", visible: false },
    Address: { text: "Address", align: "start", visible: false },
    ZipCode: { text: "Zip Code", align: "end", visible: false },
    MobileNo: { text: "Contact No.", align: "center", visible: false },
    Email: { text: "Email ID.", align: "start", visible: false },
    GSTNo: { text: "GST/VAT #", align: "center", visible: false },
    GSTEffectiveDate: { text: "GST/VAT Date",align:"center", visible: false },
    PANNo: { text: "TAX ID #", align: "center", visible: false },
    InvoiceNo: { text: "NDA/MSA Ref #", align: "center", visible: false },
  };

  const handleEdit = (id) => {
    navigate(`/client-master/edit/${id.ID}`);
  };

  const handleAddNewClient = () => {
    navigate(`/client-master/add`);
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
        <div className="row">
            <Dynamic_PR_table
              data={reportList}
              columns={columns}
              itemsPerPage={10}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              showIcon2={false}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              isActionRequired={true}
              isAddNewBtnRequired={true}
  
              showIcon3={false}
              isSorting={true}
              showIcon4={true}
              showIcon5={false}
              handleIcon1={handleEdit}
              handleAddNew={handleAddNewClient}
              // handleIcon4={handleAddSubContractor}
              add
              more
              function
              icons={{
                Icon1: <i class="bi bi-pencil-square icons"></i>,
                Icon1Text: " Edit",
                //   Icon2: <i class="bi bi-trash-fill icons"></i>,
                //   Icon3: <i class="bi bi-eye-fill icons"></i>,
                //   Icon4: <i class="bi bi-plus-square icons"></i>,
                //   Icon4Text: " Add Sub-contractor",
              }}
            />
         </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
};

export default ClientMaster;
